"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, ShieldCheck, Clock, Award } from "lucide-react";
const slides = [{
  id: 1,
  title: "The Art of Circulation",
  description: "Experience the transformative power of Compression Therapy. A sophisticated approach to lymphatic drainage and systemic wellness in Brooke.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/compression_therapy_1.png",
  ctaText: "Explore Benefits",
  ctaLink: "/MassagePage",
  badgeText: "Therapeutic Excellence"
}, {
  id: 2,
  title: "Revitalize & Recover",
  description: "Advanced pneumatic technology designed to accelerate muscle recovery and reduce inflammation for a lighter, more energized feeling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/compression_therapy_2.png",
  ctaText: "View Treatment",
  ctaLink: "https://nataliasbeauty.com/beauty-treatments-norwich/",
  newTab: true,
  badgeText: "Advanced Technology"
}, {
  id: 3,
  title: "Sculpted Wellness",
  description: "Enhance your aesthetic journey with treatments that promote fluid reduction and skin tone improvement in our serene clinic environment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/compression_therapy_3.png",
  ctaText: "The Clinic",
  ctaLink: "/TheClinicPage",
  badgeText: "Natalia's Signature"
}];
const features = [{
  id: 1,
  title: "Lymphatic Health",
  icon: ShieldCheck
}, {
  id: 2,
  title: "Rapid Recovery",
  icon: Clock
}, {
  id: 3,
  title: "Clinical Grade",
  icon: Award
}];
export default function Banner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="151189" id="compressiontherapy" ref={ref} className={`w-full bg-background text-foreground relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <Carousel opts={{
      loop: true,
      align: "start"
    }} className="w-full">
        <CarouselContent>
          {slides.map((slide, index) => <CarouselItem data-index={index} key={slide.id} className="relative w-full">
              {}
              <div className="absolute inset-0 w-full h-full">
                <img src={slide.image} alt={slide.title} className="w-full h-full object-cover object-center" />
                {}
                <div className="absolute inset-0 bg-background/30 mix-blend-overlay" />
              </div>

              {}
              <div className="relative container mx-auto px-4 md:px-6 h-[600px] md:h-[700px] lg:h-[800px] flex items-center">
                <div className="grid grid-cols-12 w-full gap-6">
                  <div className="col-span-12 md:col-span-10 lg:col-span-7 xl:col-span-6">
                    {}
                    <div className="bg-background/90 backdrop-blur-xl border border-border/30 p-8 md:p-12 shadow-xl flex flex-col items-start text-left transform transition-all duration-700 translate-y-0 opacity-100">
                      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-secondary text-secondary-foreground text-xs font-medium mb-6 uppercase tracking-widest">
                        <span className="relative flex h-2 w-2">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                          <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
                        </span>
                        {slide.badgeText}
                      </div>

                      <h1 className="text-4xl md:text-5xl lg:text-7xl font-serif font-medium text-foreground mb-6 leading-[1.1] tracking-tight">
                        {slide.title}
                      </h1>

                      <p className="text-lg md:text-xl text-muted-foreground font-sans mb-8 max-w-xl leading-relaxed">
                        {slide.description}
                      </p>

                      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                        <Button asChild size="lg" className="h-14 px-10 text-base rounded-lg shadow-lg shadow-primary/5 bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
                          <Link to={slide.ctaLink} newTab={slide.newTab}>
                            {slide.ctaText}
                            <ArrowRight className="ml-2 size-5" />
                          </Link>
                        </Button>
                        <Button asChild variant="outline" size="lg" className="h-14 px-10 text-base rounded-lg bg-transparent border-foreground/20 hover:bg-foreground/5 text-foreground transition-colors">
                          <Link to="/TheClinicPage">
                            Request Consultation
                          </Link>
                        </Button>
                      </div>

                      {}
                      <div className="mt-10 pt-6 border-t border-border/30 w-full flex flex-wrap gap-6 items-center justify-start">
                        {features.map((feature, fIndex) => {
                      const Icon = feature.icon;
                      return <div data-index={fIndex} key={feature.id} className="flex items-center gap-2 text-muted-foreground">
                              <Icon className="size-5 text-primary/60" />
                              <span className="text-sm font-sans font-medium tracking-wide">{feature.title}</span>
                            </div>;
                    })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CarouselItem>)}
        </CarouselContent>
        
        {}
        <div className="hidden md:block absolute bottom-12 right-12 lg:right-24 z-10">
          <div className="flex gap-3 bg-background/60 backdrop-blur-md p-2 rounded-lg border border-border/30 shadow-sm">
            <CarouselPrevious className="relative inset-0 translate-y-0 translate-x-0 h-12 w-12 bg-background/80 hover:bg-primary hover:text-primary-foreground border-none transition-all rounded-lg" />
            <CarouselNext className="relative inset-0 translate-y-0 translate-x-0 h-12 w-12 bg-background/80 hover:bg-primary hover:text-primary-foreground border-none transition-all rounded-lg" />
          </div>
        </div>
      </Carousel>
    </section>;
}